import { useQuery } from '@tanstack/react-query';
import { FoliarApplicationAdvice } from '../../../recommendations';
import api from '../../http';
import { useForBindingId } from '../../../forBinding';

export function useGetAdviceFoliarById(id: string) {
	const forBinding = useForBindingId();
	return useQuery({
		queryKey: ['foliar', id],
		queryFn: async () => {
			const { data } = await api.get<FoliarApplicationAdvice>(
				`/advices/foliar-application/get/${id}`, {
					params: { forBinding },
				}
			);
			return data;
		},
	});
}
